import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface CTraderSignalStatusBadgeProps {
  status: 'OPEN' | 'PROCESS' | 'REJECTED';
}

export const CTraderSignalStatusBadge = ({ status }: CTraderSignalStatusBadgeProps) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'OPEN':
        return {
          label: 'Completed',
          className: 'bg-emerald-500/20 text-emerald-500 border-emerald-500/30'
        };
      case 'PROCESS':
        return {
          label: 'Processing',
          className: 'bg-amber-500/20 text-amber-500 border-amber-500/30'
        };
      case 'REJECTED':
        return {
          label: 'Rejected',
          className: 'bg-red-500/20 text-red-500 border-red-500/30'
        };
      default:
        return {
          label: status,
          className: 'bg-gray-500/20 text-gray-500 border-gray-500/30'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge 
      variant="outline"
      className={cn('font-medium', config.className)}
    >
      {config.label}
    </Badge>
  );
};